import styled, { css } from 'styled-components';

export const OfferBanner = styled.div`
  background: #fff;
  box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.1);
  border: 1px solid #b8e986;
  border-radius: 10px;
  text-align: center;
  margin-bottom: 10px;
  margin-top: 10px;

  .TopSection {
    border-radius: 10px 10px 2px 2px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    color: #fff;
    position: relative;
    padding: 26px 30px 9px;
    background-color: rgb(143, 211, 69);
  }

  .OfferHead {
    font-size: 20px;
    line-height: 20px;
  }

  .Hr {
    width: 50px;
    height: 2px;
    border: 1px solid hsla(0, 0%, 100%, 0.5);
    display: inline-block;
  }

  .JaggedBorder {
    position: absolute;
    background-position: -11px -35px;
    width: 298px;
    height: 7px;
    display: inline-block;
    bottom: -1px;
    left: 0;
  }

  .OfferBody {
    text-align: left;
    padding: 28px 25px 28px 16px;
    font-family: Lato-Regular, Arial, Helvetica, sans-serif;
    background: #fff;
    color: #878787;
    border-radius: 10px;
  }

  .DealWrap {
    cursor: pointer;
    position: relative;
    margin: 0;
    font-size: 16px;
    color: #9b9b9b;
  }

  .OfferCode {
    border: 1px dashed #7ed321;
    background: #eeffdc;
    color: #417505;
    font-size: 16px;
    padding: 6px 11px;
    max-width: 150px;
    height: 36px;
  }

  .CopyOfferCode {
    border: 1px solid #ddd;
    padding: 7px 10px;
    font-size: 14px;
    border-left: none;
    color: #0055b7;
    cursor: pointer;
    height: 36px;
    &.selected {
      background-color: #939393;
    }
  }
`;
